import { createFileRoute } from "@tanstack/react-router";
import SaintForTreatmentResistantDepression from "@/pages/SaintForTreatmentResistantDepression";
export const Route = createFileRoute(
  "/saint-for-treatment-resistant-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "SAINT® For Treatment Resistant Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT TMS for treatment-resistant depression in Coral Springs, FL. FDA-cleared, fMRI-guided 5-day TMS for adults who haven’t improved on antidepressants.",
        },
        {
          property: "og:title",
          content:
            "SAINT® For Treatment Resistant Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT TMS for treatment-resistant depression in Coral Springs, FL. FDA-cleared, fMRI-guided 5-day TMS for adults who haven’t improved on antidepressants.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/saint-for-treatment-resistant-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-for-treatment-resistant-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintForTreatmentResistantDepression />;
}
